/* eslint-disable @stylistic/max-len */
export default function IconIceSkating() {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      aria-hidden="true"
    >
      <rect x="4" y="8" width="4" height="40" />
      <rect
        x="14"
        y="-1.5"
        width="4"
        height="23"
        transform="translate(6 26) rotate(-90)"
      />
      <rect x="24" y="8" width="4" height="14" />
      <rect
        x="25.5"
        y="23.5"
        width="4"
        height="45"
        transform="translate(-18.5 73.5) rotate(-90)"
      />
      <rect x="12" y="45" width="4" height="10" />
      <rect x="42" y="45" width="4" height="10" />
      <rect
        x="24"
        y="31"
        width="4"
        height="50"
        transform="translate(-30 82) rotate(-90)"
      />
      <path d="M58,48c0,3.31-2.14,6-4.77,6H50v4h3.4c4.74,0,8.6-4.49,8.6-10Z" />

      <path d="M50,39.44a9.77,9.77,0,0,0-6.2-8.5L30.07,25.43A3.17,3.17,0,0,1,28,22.59V21H24v1.6h0a7.17,7.17,0,0,0,4.6,6.61l13.72,5.51A5.67,5.67,0,0,1,46,39.78V47h4Z" />
    </svg>
  );
}
